
import $ from 'jquery'
import html from './objects/html'

const { parse, escape, empty } = html

const outputs = [
	{
		title : 'Graduate Leadership Programme',
		subtitle : 'Leadership',
		content : '<p>On the GLP, you’ll learn from all sides of our business. We’ll give you the tools, resources and support you need to help your customers and the business. We’ll also give you the freedom to make the right decisions for your career.</p>',
		link : '/students-graduates/graduate-leadership-programme/',
		score : {
			'1a' : 2, '1b' : 0, '1c' : 0, '1d' : 2, '1e' : 0, '1f' : 0,
			'2a' : 2, '2b' : 0, '2c' : 1, '2d' : 0, '2e' : 0, '2f' : 2,
		}
	},
	{
		title : 'Accountancy Graduate Programme',
		subtitle : 'Accountancy',
		content : '<p>It’s all about number crunching, right? Nope. Not at Aviva. Join us as a graduate accountant today and you’ll help us solve some of the biggest, most complex problems tomorrow. </p>',
		link : '/students-graduates/graduates/accountancy-graduate-scheme/',
		score : {
			'1a' : 2, '1b' : 0, '1c' : 2, '1d' : 0, '1e' : 1, '1f' : 0,
			'2a' : 0, '2b' : 0, '2c' : 0, '2d' : 2, '2e' : 0, '2f' : 2,
		}
	},
	{
		title : 'Actuarial Graduate Programme',
		subtitle : 'Actuarial',
		content : '<p>If you’re a natural problem solver, this is the place to be. As a graduate on our Actuarial programme, yours will be an influential voice when it comes to reporting, pricing, valuations and solvency.</p>',
		link : '/students-graduates/graduates/actuarial-graduate-scheme/',
		score : {
			'1a' : 2, '1b' : 0, '1c' : 2, '1d' : 0, '1e' : 1, '1f' : 0,
			'2a' : 0, '2b' : 0, '2c' : 0, '2d' : 2, '2e' : 0, '2f' : 2,
		}
	},
	{
		title : 'Change Management Pathway',
		subtitle : 'Technology',
		content : '<p>Our Change Management Pathway is suited to people who are naturally curious – big picture thinkers who aren’t afraid to challenge the status quo. If you enjoy organising, whether that’s information or people, and you like to influence thinking and the way things are done, this route could be a good match for you.</p>',
		link : '/students-graduates/graduates/technology/',
		score : {
			'1a' : 1, '1b' : 2, '1c' : 0, '1d' : 2, '1e' : 1, '1f' : 2,
			'2a' : 2, '2b' : 2, '2c' : 1, '2d' : 0, '2e' : 2, '2f' : 0,
		}
	},
	{
		title : 'Software Development',
		subtitle : 'Technology',
		content : '<p>Our Software Development graduates are key to helping us to connect with our customers in a reliable, safe and engaging way. If you think logically, enjoy problem solving, are curious about how things work and have some knowledge of coding, this could be the pathway for you.</p>',
		link : '/students-graduates/graduates/technology/',
		score : {
			'1a' : 0, '1b' : 1, '1c' : 2, '1d' : 2, '1e' : 0, '1f' : 1,
			'2a' : 0, '2b' : 2, '2c' : 0, '2d' : 0, '2e' : 0, '2f' : 0,
		}
	},
	{
		title : 'User Experience (UX) Design',
		subtitle : 'Technology',
		content : '<p>Our User Experience (UX) Design team focuses on designing interfaces that offer a great experience to users. From how people access our websites and apps, to their usability and accessibility, it’s our UX teams that are responsible for this.</p>',
		link : '/students-graduates/graduates/technology/',
		score : {
			'1a' : 0, '1b' : 0, '1c' : 0, '1d' : 0, '1e' : 0, '1f' : 1,
			'2a' : 0, '2b' : 0, '2c' : 0, '2d' : 1, '2e' : 1, '2f' : 0,
		}
	}
]

const questions = [
	{
		byline : '1 of 2',
		title : 'Which of the following traits best describes&nbsp;you?',
		subtitle : '',
		content : 'Select three items',
		selectMin : 3,
		selectMax : 3,
		options : {
			'1a' : 'I’m driven',
			'1b' : 'I’m inventive',
			'1c' : 'I’m analytical',
			'1d' : 'I’m adaptable',
			'1e' : 'I’m collaborative',
			'1f' : 'I’m curious'
		}
	},
	{
		byline : '2 of 2',
		title : 'Which of the following strengths do you possess?',
		subtitle : '',
		content : 'Select three items',
		selectMin : 3,
		selectMax : 3,
		options : {
			'2a' : 'I never back down from a challenge',
			'2b' : 'I like solving problems',
			'2c' : 'I test every solution',
			'2d' : 'I keep things simple',
			'2e' : 'I pride myself on being organised',
			'2f' : 'I like to encourage others'
		}
	},
]

const answerData = {
	byline : '',
	title : 'Nice going!',
	subtitle : 'Your future is just a click away',
	content : 'Based on your answers we think you\'ll be a great fit at Aviva. There are actually a number of opportunities you\'d be well-suited to! See which ones appeal to you, and we\'ll look forward to receiving your application soon.',
	sidebarTitle : 'Still not sure?',
	sidebarContent : 'Have another go at seeing where you might best fit.',
}

function header({ byline = '', title = '', subtitle = '' }) {
	return parse(`<div class="page-max-width--medium padding-2">
		${ byline && `<div class="m-modal__byline">${byline}</div>` || '' }
		<h2 class="u-margin--top-none m-modal__heading-1 heading-2" id="modal-grad-tool-title">${title}</h2>
		${ subtitle && `<p class="p--large">${subtitle}</p>` || '' }
	</div>`)
}

function question(q, onNext = () => {}, onChange = () => {}) {

	const { content = '', selectMax = 1, selectMin = 1, options : opts = {} } = q
	const el = parse(
		`<div class="padding-2 page-max-width--medium">
			<div class="grid grid--inline">
				<div class="col-12 margin-bottom-2">
					<fieldset class="m-form-row">
						<legend class="a-label"><small>${content} <span class="js-selected opacity-05"></span></small></legend>
						<div class="m-form-row__content">
							<div class="grid grid-padding-1">
								${ Object.entries(opts).map(([ key, text ]) => {
									return `<div class="col-12 col-6@medium">
										<label class="a-checkbox" for="${escape(key)}">
											<input class="a-checkbox__input" name="${escape(key)}" id="${escape(key)}" type="checkbox" value="${escape(text)}">
											<span class="a-checkbox__label"><span class="a-checkbox__label-inner">${text}</span></span>
											<span class="a-checkbox__ui"></span>
										</label>
									</div>`
								}).filter(Boolean).join('') }
							</div>
						</div>
					</fieldset>
					<fieldset class="m-form-row">
						<button type="button" class="a-button a-button--primary js-next" disabled>Next</button>
					</fieldset>
				</div>
			</div>
		</div>
	`)
	
	const options = [...el.querySelectorAll('input')]
	const selected = el.querySelector('.js-selected')
	const next = el.querySelector('.js-next')

	let numSelected = 0

	const setSelected = num => {
		const text = selectMax && `(${num}/${selectMax} selected)` || ''
		selected.innerText = text
	}

	const changeHandler = event => {
		const el = event.currentTarget
		const checked = el.checked
		if (!checked) numSelected--
		if (checked) numSelected++
		if (numSelected >= selectMax) options.map(el => !el.checked && el.parentNode.classList.add('is-disabled'))
		if (numSelected < selectMax) options.map(el => !el.checked && el.parentNode.classList.remove('is-disabled'))
		if (numSelected >= selectMin) next.disabled = false
		if (numSelected < selectMin) next.disabled = true
		setSelected(numSelected)
		onChange()
	}

	options.map(el => el.addEventListener('change', changeHandler))
	next.addEventListener('click', onNext)

	return el
}

function answer(form, restart) {

	const selections = form.length
	const selectionMap = form.reduce((map, { name }) => {
		if (typeof map[name] === 'undefined') map[name] = 0
		map[name]++
		return map
	}, {})

	let highScore = 0
	
	const outputsWithScore = outputs.map(output => {
		output.total = total(output)
		return output
	}).sort((a, b) => b.total - a.total)

	let hidden = false
	
	const el = parse(`
		<div class="padding-2 page-max-width--medium">
			<div class="grid">
				<div class="col-12 col-9@large margin-bottom-2">
					${ answerData.content && `<p class="p--large">${answerData.content}</p>` || '' }
				</div>
			</div>
			<div class="grid">
				<div class="col-12 col-9@large margin-bottom-2">
					${ outputsWithScore.map((output, index) => {

						const { title, subtitle, content, link, total } = output
						const first = index === 0
						const percentage = round10(total / highScore * 100)
						const boxClass = percentage === 100 ? 'm-expand-box--highlight' : ''
						const expandClass = first ? 'm-expand-box--expanded' : ''
						const progressClass = percentage >= 75 ? 'm-progress--green' : ''
						const hideClass = percentage <= 50 ? 'hide' : ''
						if (percentage <= 50) hidden = true

						return `<div class="m-expand-box ${boxClass} ${expandClass} ${hideClass}">
							${title && `<h3 class="m-expand-box__title"><a href="${link}">${title}</a></h3>` || '' }
							${subtitle && `<h4 class="m-expand-box__subtitle">${subtitle}</h4>` || ''}
							
							${!first && `<small class="m-expand-box__expand"><a class="js-expand" href="javascript:;">Expand</a></small>` || ''}

							<div class="m-progress ${progressClass}">
								<div class="m-progress__title">${percentage}% match</div>
								<div class="m-progress__bar"><div class="m-progress__bar__inner" style="width:${percentage}%;"></div></div>
							</div>

							<div class="m-expand-box__content">
								<small>
									${content}
									${link && `<p class="m-card-readmore"><a class="js-cta" href="${link}">Find out more</a></p>` || ''}
								</small>
							</div>
						</div>`

					}).filter(Boolean).join('') }

					${hidden && `<button type="button" class="a-button a-button--primary js-show-all">Show all programmes</button>` || ''}

				</div>
				<div class="col-12 col-3@large">
					<div class="line-top">
						<p><strong>${answerData.sidebarTitle}</strong></p>
						<p>${answerData.sidebarContent}</p>
						<p class="m-card-readmore"><a href="javascript:;" class="js-restart">Restart</a></p>
					</div>
				</div>
			</div>
		</div>
	`).firstElementChild

	const links = [...el.querySelectorAll('.m-expand-box')].map(el => {
		const title = el.querySelector('h3').innerText
		const expand = el.querySelector('.js-expand')
		const cta = el.querySelector('.js-cta')
		
		expand && expand.addEventListener('click', event => {
			const isExpanded = el.classList.contains('m-expand-box--expanded')
			const message = isExpanded ? 'Close' : 'Expand'
			trackClick(`${message}: ${title}`)
		})

		cta && cta.addEventListener('click', event => trackClick('Click: ' + title))
	})

	const restartButton = el.querySelector('.js-restart').addEventListener('click', () => {
		trackClick('Restart')
		restart()
	})
	const showAll = el.querySelector('.js-show-all')
	
	showAll && showAll.addEventListener('click', function() {
		;[...el.querySelectorAll('.hide')].map(el => el.classList.remove('hide'))
		showAll.classList.add('hide')
	})

	;[...el.querySelectorAll('.m-expand-box__expand')].map(el => {
		el.addEventListener('click', function(ev) {
			ev.currentTarget.closest('.m-expand-box').classList.toggle('m-expand-box--expanded')
		})
	})

	return el

	function total(output) {
		let total = 0
		const scoreEntries = Object.entries(output.score)
		scoreEntries.map(([name, num]) => {
			if (selectionMap[name]) total = total + (num * selectionMap[name])
		})
		if (total > highScore) highScore = total
		return total
	}
}

function app(form, head, content) {

	const answerPage = document.createElement('div')
	content.appendChild(answerPage)

	const pages = [
		...questions.map((q, index) => {
			const frag = question(
				q, 
				() => {
					window.gaTrackPageview && window.gaTrackPageview(`pathfinder/page-${index + 2}`)
					move(index + 1)
				},
				updateAnswer
			)
			const el = frag.firstElementChild
			content.appendChild(frag)
			return el
		}),
		answerPage
	]

	pages.map((screen, index) => index > 0 && (screen.style.display = 'none'))
	let current = 0
	move(0)

	function move(to) {

		const isAnswer = to > questions.length - 1
		const data = isAnswer ? answerData : questions[to]
		updateAnswer()

		// fade out
		head.style.opacity = '0.5'
		pages[current].style.opacity = '0.5'
		pages[current].style.display = 'block'
		
		setTimeout(function() {
			// fade new in
			empty(head)
			head.appendChild(header(data))
			head.style.opacity = ''

			pages[current].style.display = 'none'
			pages[current].style.opacity = ''
			pages[to].style.display = 'block'
			current = to
		}, 200)
	}

	function updateAnswer() {
		empty(answerPage)
		answerPage.appendChild(
			answer($(form).serializeArray(), () => {
				window.gaTrackPageview && window.gaTrackPageview(`pathfinder/page-1`)
				move(0)
				;[...form.querySelectorAll('input')].map(input => {
					if (!input.checked) return
					input.checked = false
					
					// trigger change event to update page data
					const event = document.createEvent('Event');
					event.initEvent('change', true, true);
					input.dispatchEvent(event);
				})
			})
		)
	}

	window.move = move
}

function round10(x) {
	return Math.round(x/10)*10;
}

function trackClick(label) {
	window.gtag && window.gtag('event', 'click', {
		'event_category' : 'Pathfinder',
		'event_label' : label
	})
}


export const initInstance = function(el) {
	app(
		el, 
		el.querySelector('.js-gradtool-header'), 
		el.querySelector('.js-gradtool-content')
	)

	const open = () => {
		MicroModal && MicroModal.show('modal-grad-tool')
		window.gaTrackPageview && window.gaTrackPageview(`pathfinder/page-1`)
	}

	const modalHash = '#pathfinder'

	// trigger modal when hash is '#pathfinder'
	if (location.hash === modalHash) open()

	// trigger modal when links clicked with href="#pathfinder"
	document.addEventListener('click', event => {
		const isLink = node => node.nodeType === 1 && node.tagName === 'A'
		let node = event.target
		while (node) {
			if (isLink(node)) break;
			node = node.parentNode
		}
		if (!node) return
		event.stopPropagation()
		if (node.getAttribute("href") === modalHash) {
			event.preventDefault()
			open()
		}
	})
}
